export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Show less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["閉じる"])},
      "Show more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もっと見る"])}
    }
  })
}
